import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {PageGrid} from '@/component';
import {getColumns} from '@/page/customer/TransferPage/transferColumns';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';

function TransferTable({transferType = '1', isRoom = '0'}) {
    const [url, setUrl] = useState(null);
    const [authStore] = useAuthStore();
    const id = _.get(authStore, 'user.id');
    let columns = getColumns([
        'handoverUser',
        'takeoverUser',
        'takeoverTime',
        'status',
        'errorCode',
    ]);
    columns.push(
        isRoom === '0'
            ? {
                  title: '被交接客户',
                  dataIndex: 'transferCustomer',
                  render: transferCustomer => transferCustomer.name,
              }
            : {
                  title: '被交接群组',
                  dataIndex: 'transferRoom',
                  render: transferRoom => transferRoom.name,
              }
    );
    useEffect(() => {
        setUrl('/transfer/list');
    }, [transferType, isRoom]);

    return (
        <div>
            {url && (
                <PageGrid
                    url={url}
                    columns={columns}
                    initParams={{
                        isRoom,
                        transferType,
                        id,
                    }}
                />
            )}
        </div>
    );
}

TransferTable.prototypes = {
    // 1在职 2离职
    transferType: PropTypes.String,
    // 0个人 1群聊
    isRoom: PropTypes.String,
};

export default TransferTable;
